
<main class="main d-flex align-items-center">
  <div class="container">
    <div class="row">
      <div class="col-md-8 mx-auto">
        <div class="card-group">
          <div class="card p-4">
            <div class="card-body">
              <form [formGroup]="profileForm" (ngSubmit)="onSubmit()" class="ng-untouched ng-pristine ng-invalid">
                <h1 style="color: #000;">Login</h1>
                <p class="text-muted">Sign In to your account</p>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text"
                      ><i class="fa fa-user" aria-hidden="true"></i>
                    </span>
                  </div>
                  <input
                    type="text"
                    placeholder="Registered Email or Mobile"
                    formControlName="userid"
                    autocomplete="userid"
                    required=""
                    class="form-control ng-untouched ng-pristine ng-invalid"
                  />
                </div>
                <div class="input-group mb-4">
                  <div class="input-group-prepend">
                    <span class="input-group-text"
                      ><i class="fa fa-lock" aria-hidden="true"></i>
                    </span>
                  </div>
                  <input
                    type="password"
                    placeholder="Password"
                    formControlName="password"
                    autocomplete="current-password"
                    required=""
                    class="form-control ng-untouched ng-pristine ng-invalid"
                  />
                </div>
                <div class="row">
                  <div class="col-6">
                    <re-captcha (success)="handleSuccess($event)" formControlName="recaptcha"></re-captcha>
                    <button type="button" type="submit" class="btn cus-btn-primary px-4">
                      Login
                    </button>
                  </div>
                  <div class="col-6 text-right">
                    <button type="button" class="btn btn-link px-0">
                      Forgot password?
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div
            class="card text-white  py-5 d-md-down-none"
            style="width: 44%; background: #20a8d8 "
          >
            <div class="card-body text-center">
              <div>
                <h2>Sign up</h2>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </p>
                <button routerLink="/register" routerLinkActive="active"  class="btn btn_reg active mt-3">
                  Register Now!
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>



<style>
  .main.d-flex{
    background: #e4e5e6;
    height: 100vh;
  }
  .cus-btn-primary{
    color: #fff;
    background-color: #20a8d8 !important;
    border-color: #20a8d8 !important;
  }
  .cus-btn-primary:hover, .btn_reg {
    color: #fff;
    background-color: #1b8eb7 !important;
    border-color: #1985ac !important;
  }
  .btn_reg:hover{
    background-color: #000;

  }
  h1, h2{
    font-size: 24px;
  }
  p{
    font-size: 14px;
    line-height: 20px;
  }
  .btn-link{
    font-weight: 400;
    color: #20a8d8;
    text-decoration: none;
  }
</style>
